var VolumeStatus = {
  ATTACHED: "Attached",
  DETACHED: "Detached",
  UNAVAILABLE: "Unavailable"
};

module.exports = VolumeStatus;



// WEBPACK FOOTER //
// ./plugins/services/src/js/constants/VolumeStatus.js